const actions = {
    FETCH_SALARY_MONTH_DECLARATIONS: 'FETCH_SALARY_MONTH_DECLARATIONS',
    FETCH_SALARY_MONTH_DECLARATION: 'FETCH_SALARY_MONTH_DECLARATION',
    RESET_SALARY_MONTH_DECLARATION: 'RESET_SALARY_MONTH_DECLARATION',

    fetchSalaryMonthDeclarationsAction: (data) => {
        return {
            type: actions.FETCH_SALARY_MONTH_DECLARATIONS,
            data: data
        };
    },
    resetSalaryMonthDeclarationFormAction: () => {
        return {
            type: actions.RESET_SALARY_MONTH_DECLARATION,
            data: null
        };
    },
    fetchSalaryMonthDeclarationAction: (data) => {
        return {
            type: actions.FETCH_SALARY_MONTH_DECLARATION,
            data: data
        };
    },
};

export default actions;
